var Haiku = require("@haiku/core");
var _code_circle_code = require("./../circle/code.js");
module.exports = {
  metadata: {
    uuid: "e645986d-a395-46f2-9d2a-6944ec235fb7",
    version: "0.0.1",
    organization: "Tina",
    project: "AnimatorWebsiteIcon6",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon6",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/0f9a2fb9-3bf3-4c64-9b2d-1a9af15c3253/5c51f21e1f76d3ec3900c58fb722be9bdc65c090/",
    core: "4.5.1",
    title: "Main",
    type: "haiku",
    relpath: "code/main/code.js"
  },
  options: {},
  states: { play: { type: "string", value: "stop", edited: true } },
  eventHandlers: {
    "haiku:Main-03757d2ca1026e0a": {
      hover: {
        handler: function(component, element, target, event) {
          this.setState({ play: "loop" });
        }
      },
      unhover: {
        handler: function(component, element, target, event) {
          this.setState({ play: "stop" });
        }
      }
    }
  },
  timelines: {
    Default: {
      "haiku:Stop-cbbec078c7b753d4": { stopColor: "#F75D4A", offset: "0%" },
      "haiku:Main-03757d2ca1026e0a": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "hidden",
        "style.overflowY": "hidden",
        "sizeAbsolute.x": 99.318,
        "sizeAbsolute.y": 94.168,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:Linear-Gradient-1-Fc3746-e21a40021d30756c": {
        x1: "25.334317%",
        y1: "12.6679657%",
        x2: "70.188054%",
        y2: "86.2801745%"
      },
      "haiku:Stop-d8f1a16f278bb338": { stopColor: "#F75D4A", offset: "0%" },
      "haiku:Stop-56a33e66137b3909": { stopColor: "#FFAC39", offset: "100%" },
      "haiku:Linear-Gradient-2-Fc3746-68bd8ee6d3c57ffd": {
        x1: "11.4598703%",
        y1: "45.8519962%",
        x2: "81.5438343%",
        y2: "54.0311305%"
      },
      "haiku:Stop-6454463cd076a1cf": { stopColor: "#F75D4A", offset: "0%" },
      "haiku:Stop-87f0588953458ef9": { stopColor: "#FFAC39", offset: "100%" },
      "haiku:Linear-Gradient-3-Fc3746-098cc8cbb5a1900a": {
        x1: "11.4598703%",
        y1: "49.416687%",
        x2: "81.5438343%",
        y2: "50.5668777%"
      },
      "haiku:Stop-7b12c5a8cefc0b11": { stopColor: "#F75D4A", offset: "0%" },
      "haiku:Stop-1f3161eee4c7b63a": { stopColor: "#FFAC39", offset: "100%" },
      "haiku:Linear-Gradient-4-Fc3746-19aa2c61137b7b37": {
        x1: "15.4099667%",
        y1: "12.6679657%",
        x2: "78.3108097%",
        y2: "86.2801745%"
      },
      "haiku:Papers-d4461b8c91e64063": {
        "sizeMode.x": 1,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 34,
        "style.margin": "0",
        "sizeAbsolute.y": 35,
        "sizeMode.y": 1,
        "translation.x": 49.659,
        "translation.y": 47.083999999999996,
        "style.zIndex": 1
      },
      "haiku:Stop-877a3646729b4502": { stopColor: "#FFAC39", offset: "100%" },
      "haiku:Page-1-ea3a3dd8eb68a7c5": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Help-Icon-b99199de69ed6bcb": {
        fillRule: "nonzero",
        "translation.x": -13,
        "translation.y": -14
      },
      "haiku:Papers-163f736c8fd914c9": {
        "translation.x": 13.664102,
        "translation.y": 14.3
      },
      "haiku:Shape-b431a2103f12b448": {
        d:
          "M18.9,14.4 L13.5,14.4 C13.0032,14.4 12.6,13.9968 12.6,13.5 L12.6,6.3 C12.6,5.8032 13.0032,5.4 13.5,5.4 L18.9,5.4 C19.3968,5.4 19.8,5.8032 19.8,6.3 L19.8,13.5 C19.8,13.9968 19.3968,14.4 18.9,14.4 Z M14.4,12.6 L18,12.6 L18,7.2 L14.4,7.2 L14.4,12.6 Z",
        fill: "url(#linearGradient-1-fc3746)"
      },
      "haiku:Path-ecb3a0ba3dc31c7d": {
        d:
          "M9.9,7.2 L6.3,7.2 C5.8032,7.2 5.4,6.7968 5.4,6.3 C5.4,5.8032 5.8032,5.4 6.3,5.4 L9.9,5.4 C10.3968,5.4 10.8,5.8032 10.8,6.3 C10.8,6.7968 10.3968,7.2 9.9,7.2 Z",
        fill: "url(#linearGradient-2-fc3746)"
      },
      "haiku:Path-cd890fb93cdcfd47": {
        d:
          "M9.9,10.8 L6.3,10.8 C5.8032,10.8 5.4,10.3968 5.4,9.9 C5.4,9.4032 5.8032,9 6.3,9 L9.9,9 C10.3968,9 10.8,9.4032 10.8,9.9 C10.8,10.3968 10.3968,10.8 9.9,10.8 Z",
        fill: "url(#linearGradient-2-fc3746)"
      },
      "haiku:Path-b127349ca183478d": {
        d:
          "M9.9,14.4 L6.3,14.4 C5.8032,14.4 5.4,13.9968 5.4,13.5 C5.4,13.0032 5.8032,12.6 6.3,12.6 L9.9,12.6 C10.3968,12.6 10.8,13.0032 10.8,13.5 C10.8,13.9968 10.3968,14.4 9.9,14.4 Z",
        fill: "url(#linearGradient-2-fc3746)"
      },
      "haiku:Path-516f4fa4ec8326b8": {
        d:
          "M18.9,18 L6.3,18 C5.8032,18 5.4,17.5968 5.4,17.1 C5.4,16.6032 5.8032,16.2 6.3,16.2 L18.9,16.2 C19.3968,16.2 19.8,16.6032 19.8,17.1 C19.8,17.5968 19.3968,18 18.9,18 Z",
        fill: "url(#linearGradient-3-fc3746)"
      },
      "haiku:Path-865593a3da835802": {
        d:
          "M18.9,21.6 L6.3,21.6 C5.8032,21.6 5.4,21.1968 5.4,20.7 C5.4,20.2032 5.8032,19.8 6.3,19.8 L18.9,19.8 C19.3968,19.8 19.8,20.2032 19.8,20.7 C19.8,21.1968 19.3968,21.6 18.9,21.6 Z",
        fill: "url(#linearGradient-3-fc3746)"
      },
      "haiku:Shape-f60593878252aae1": {
        d:
          "M29.7,7.2 L28.8,7.2 L28.8,6.3 C28.8,4.8114 27.5886,3.6 26.1,3.6 L25.2,3.6 L25.2,2.7 C25.2,1.2114 23.9886,0 22.5,0 L2.7,0 C1.2114,0 0,1.2114 0,2.7 L0,24.3 C0,25.7886 1.2114,27 2.7,27 L3.6,27 L3.6,27.9 C3.6,29.3886 4.8114,30.6 6.3,30.6 L7.2,30.6 L7.2,31.5 C7.2,32.9886 8.4114,34.2 9.9,34.2 L29.7,34.2 C31.1886,34.2 32.4,32.9886 32.4,31.5 L32.4,9.9 C32.4,8.4114 31.1886,7.2 29.7,7.2 Z M1.8,24.3 L1.8,2.7 C1.8,2.2032 2.2032,1.8 2.7,1.8 L22.5,1.8 C22.9968,1.8 23.4,2.2032 23.4,2.7 L23.4,24.3 C23.4,24.7968 22.9968,25.2 22.5,25.2 L2.7,25.2 C2.2032,25.2 1.8,24.7968 1.8,24.3 Z M5.4,27.9 L5.4,27 L22.5,27 C23.9886,27 25.2,25.7886 25.2,24.3 L25.2,5.4 L26.1,5.4 C26.5968,5.4 27,5.8032 27,6.3 L27,27.9 C27,28.3968 26.5968,28.8 26.1,28.8 L6.3,28.8 C5.8032,28.8 5.4,28.3968 5.4,27.9 Z M30.6,31.5 C30.6,31.9968 30.1968,32.4 29.7,32.4 L9.9,32.4 C9.4032,32.4 9,31.9968 9,31.5 L9,30.6 L26.1,30.6 C27.5886,30.6 28.8,29.3886 28.8,27.9 L28.8,9 L29.7,9 C30.1968,9 30.6,9.4032 30.6,9.9 L30.6,31.5 Z",
        fill: "url(#linearGradient-4-fc3746)"
      },
      "haiku:Circle-96c2a699de7b3a08": {
        "translation.x": 48.780249999999995,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "sizeAbsolute.y": "auto",
        "style.margin": "0",
        "translation.y": 49.019,
        "sizeMode.z": 1,
        "origin.x": 0.5,
        "origin.y": 0.5,
        "style.zIndex": 2,
        playback: {
          "0": {
            value: Haiku.inject(function(play) {
              return play;
            }, "play"),
            edited: true
          }
        },
        PlayIt: {
          "0": {
            value: Haiku.inject(function(play) {
              return play;
            }, "play"),
            edited: true
          }
        }
      }
    }
  },
  template: {
    elementName: "div",
    attributes: { "haiku-id": "Main-03757d2ca1026e0a", "haiku-title": "Main" },
    children: [
      {
        elementName: _code_circle_code,
        attributes: {
          "haiku-id": "Circle-96c2a699de7b3a08",
          "haiku-var": "_code_circle_code",
          "haiku-title": "Circle",
          "haiku-source": "./code/circle/code.js"
        },
        children: []
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Papers-d4461b8c91e64063",
          "haiku-title": "Papers",
          "haiku-source":
            "designs/AnimatorWebsiteIcon6.sketch.contents/slices/Papers.svg"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-8c87eaf12f3916f7" },
            children: [
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "Linear-Gradient-1-Fc3746-e21a40021d30756c",
                  id: "linearGradient-1-fc3746"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-d8f1a16f278bb338" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-56a33e66137b3909" },
                    children: []
                  }
                ]
              },
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "Linear-Gradient-2-Fc3746-68bd8ee6d3c57ffd",
                  id: "linearGradient-2-fc3746"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-6454463cd076a1cf" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-87f0588953458ef9" },
                    children: []
                  }
                ]
              },
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "Linear-Gradient-3-Fc3746-098cc8cbb5a1900a",
                  id: "linearGradient-3-fc3746"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-7b12c5a8cefc0b11" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-1f3161eee4c7b63a" },
                    children: []
                  }
                ]
              },
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "Linear-Gradient-4-Fc3746-19aa2c61137b7b37",
                  id: "linearGradient-4-fc3746"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-cbbec078c7b753d4" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-877a3646729b4502" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-ea3a3dd8eb68a7c5", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Help-Icon-b99199de69ed6bcb",
                  id: "Help-icon"
                },
                children: [
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "Papers-163f736c8fd914c9",
                      id: "Papers"
                    },
                    children: [
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Shape-b431a2103f12b448",
                          id: "Shape"
                        },
                        children: []
                      },
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Path-ecb3a0ba3dc31c7d",
                          id: "Path"
                        },
                        children: []
                      },
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Path-cd890fb93cdcfd47",
                          id: "Path"
                        },
                        children: []
                      },
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Path-b127349ca183478d",
                          id: "Path"
                        },
                        children: []
                      },
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Path-516f4fa4ec8326b8",
                          id: "Path"
                        },
                        children: []
                      },
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Path-865593a3da835802",
                          id: "Path"
                        },
                        children: []
                      },
                      {
                        elementName: "path",
                        attributes: {
                          "haiku-id": "Shape-f60593878252aae1",
                          id: "Shape"
                        },
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon6/code/main/code.js
// module id = 459
// module chunks = 127651196306611